// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.particularCategoryEachItemGridContainer {
  display: flex;
  align-content: flex-start;
  flex: 1;
  flex-wrap: wrap !important;
  overflow-y: scroll !important;
  padding: 14px !important;
  border-radius: 4px;
  border: 0.2px solid #bcbcbc;
  margin-right: 10px;
  box-shadow: 4px 4px 4px 0px #00000040 !important;
}

.particularCategoryEachItem {
  width: 146px !important;
  margin-right: 6px !important;
  height: 150px;
  padding-bottom: 1vh !important;
  border-radius: 5px !important;
  margin-bottom: 2vh !important;
  border: 0.2px solid #bcbcbc;
  box-shadow: 4px 4px 4px #00000040;
  min-width: 10rem;
  text-align: center;
  padding: 4px;
  background-color: #fff;
}

.particularCategoryEachItemImgContainer {
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  margin-bottom: 10px;
  position: relative;
}

.particularCategoryEachItemImg {
  width: 100% !important;
  height: 100px !important;
  object-fit: cover !important;
  border-radius: 5px !important;
}

/* For Catefory Products view */
.particularCategoryEachItemGridContainerCFSCartPage {
  /* display: grid;
  align-content: flex-start; */
  flex: 1;
  flex-wrap: wrap !important;
  overflow-y: scroll !important;
  overflow-x: hidden !important;
  height: 100% !important;
  padding-top: 10px !important;
  border-radius: 4px;
  /* scrollbar-width: thin; */
  scrollbar-color: #a0aec0 transparent;
  padding-right: 6px;
}

.particularCategoryEachItemGridContainerCFSCartPage::-webkit-scrollbar {
  width: 6px !important;
}
.particularCategoryEachItemGridContainerCFSCartPage::-webkit-scrollbar-thumb {
  background: #a0aec0 !important;
  border-radius: 4px !important;
}
.particularCategoryEachItemGridContainerCFSCartPage::-webkit-scrollbar-track {
  background: transparent !important;
}

.particularCategoryEachItemCFS {
  width: 100% !important;
  min-width: 0 !important;
  border-radius: 12px !important;
  margin-bottom: 0 !important;
  border: none;
  background-color: transparent;
  overflow: hidden;
  padding: 3px;
  box-sizing: border-box;
}

.particularCategoryEachItemCFS.dark {
  border: none !important;
}

.particularCategoryEachItemCFS.keyboard-focused {
  border: 2px solid #3b82f6 !important;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.25);
  background-color: #eff6ff !important;
}

.particularCategoryEachItemImgContainerCFS {
  width: 100%;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  margin-bottom: 10px;
  position: relative;
}

.particularCategoryEachItemImgCFS {
  width: 100%;
  height: 120px;
  object-fit: cover;
  border-radius: 5px !important;
}

.foodTypeIcon {
  height: 14px;
  width: 14px;
  position: absolute;
  left: 88%;
  bottom: 82%;
}

.particularElementNameContainerCFS {
  display: flex;
  justify-content: space-between;
  align-items: center !important;
}

.particularElementNameCFS {
  text-transform: uppercase !important;
  font-weight: 700;
  word-wrap: break-word;
  white-space: normal;
  overflow-wrap: break-word;
  max-width: 110px;
  line-height: 1.1;
}

.particularElementNameCFSPrice {
  font-size: 0.75rem;
  font-weight: 700;
  color: #2a71ff;
}
/* Til Here */

.particularCategoryEachItemGridContainer::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}

.particularCategoryEachItemGridContainer::-webkit-scrollbar {
  width: 3px;
  height: 3px;
  background-color: #f5f5f5;
}

.particularCategoryEachItemGridContainer::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #cbcbcb;
}

.dark .particularCategoryEachItem {
  background-color: #353a50 !important;
  color: white !important;
}

.light .particularCategoryEachItem {
  background-color: white !important;
  color: black !important;
}

.drawerCloseIcon {
  cursor: pointer;
  display: flex;
  justify-content: flex-end;
}

.drawerCloseIcon ::selection {
  color: #7ed957;
}

.closePopCrossIcon {
  color: white !important;
}

.popUpInput {
  padding: 5px !important;
  border-radius: 6px !important;
  width: 100%;
  margin-bottom: 20px !important;
}

.popUpVerifyBtn {
  margin-left: 8%;
  font-size: medium;

  border: none !important;
  color: #7ed957;
  cursor: pointer;
}

.popUpVerifyBtn1 {
  margin-left: 8%;
  font-size: medium;
  color: white;
  cursor: pointer;
}

.skipBtnContainer {
  display: flex !important;
  width: 100% !important;
}

.skipNowbtn {
  cursor: pointer !important;
}

.particular-cat-container {
  background-color: #eef0f4;
  padding-left: 4px;
  padding-right: 0;
  height: 98%;
  margin-top: 50px;
  width: 100% !important;
}

.particular-cat-container-inner {
  height: 100vh;
}

@media (max-width: 576px) {
  .particular-cat-container {
    padding: 0.5rem;
  }
}

.dark .particular-cat-container {
  background-color: #2b2f42;
}

.leftContainer {
  padding-right: 5px;
  /* border: 0.5px solid #bcbcbc; */
  overflow: hidden;
  position: relative;
  border-radius: 2px;
  /* padding: 10px; */
  /* background-color: #fff; */
  height: 100% !important;
}

.select-items-container {
  display: flex;
  flex-direction: column;
  min-width: 40%;
}

.select-item-details {
  color: gray;
  font-size: 1rem;
  font-weight: bold;
}

.addCustomericonsDiv {
  display: flex;
  align-content: center;
  color: white;
}

.subContainer {
  width: 100%;
}

.inputText {
  width: 100%;
  border-radius: 20px;
  border: 1px solid black;
  padding: 7px 0px;
  padding-left: 2vw;
  height: 5vh;
  margin-bottom: 1vh;
}

.categoryText {
  display: flex;
  justify-content: flex-start !important;
  color: white;
  margin-top: 2vh !important;
  margin-bottom: 1vh;
}

.categoryText h4 {
  font-size: 1.5rem;
}

.dark .categoryText {
  color: white;
}

.light .categoryText {
  color: black;
}

.customers {
  margin-top: 5vh;
  margin-bottom: 1vh;
  font-size: 1rem;
}

.dark .customers {
  color: white;
}

.light .customers {
  color: black;
}

/* Old Particular Categories styles */

.categoryContainer {
  display: flex;
  justify-content: flex-start;
  overflow-x: auto !important;
  margin-bottom: 1rem;
}

.categoryContainer::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}

.categoryContainer::-webkit-scrollbar {
  width: 3px;
  height: 3px;
  background-color: #f5f5f5;
}

.categoryContainer::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #cbcbcb;
}

.light .customerDivParticularCategory:focus {
  outline: none;
}

.dark .customerDivParticularCategory:focus {
  outline: none;
}

.customerDivParticularCategory {
  border-radius: 5px;
  min-width: fit-content !important;
  height: 5vh !important;
  margin-right: 5%;
  align-items: center !important;
  text-align: center !important;
  font-size: 1rem !important;
  font-weight: 400 !important;
  cursor: pointer;
  display: flex;
  border: 1px solid #2a71ff;
  color: #2a71ff !important;
}

.categoryContainer .customerDivParticularCategory {
  padding: 8px !important;
  height: 44px !important;
}

.customerDivParticularCategory:focus {
  background-color: #e3e8ff !important;
  color: #0562fb !important;
  border: solid 1px #0562fb !important;
}

.dark .customerDivParticularCategory {
  background-color: var(--dark-blue);
  color: white;
}

.light .customerDivParticularCategory {
  background-color: white;
  color: black;
}

/* Till Hear */

/* New Particular Categories styles */

.particularCategoryContainer {
  display: flex;
  justify-content: flex-start;
  overflow-x: auto !important;
  gap: 7px !important;
  scrollbar-width: none;
  -ms-overflow-style: none;
  width: 100%;
}

.particularCategoryContainer::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}

.particularCategoryContainer::-webkit-scrollbar {
  display: none;
}

.particularCategoryContainer::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #cbcbcb;
}

.light .particularCustomerDivCategory:focus {
  outline: none;
}

.dark .particularCustomerDivCategory:focus {
  outline: none;
}

.particularCustomerDivCategory {
  border-radius: 5px;
  font-size: 0.813rem !important;
  font-weight: 400 !important;
  border: 1px solid #2a71ff;
  color: #2a71ff !important;
  display: flex;
  text-align: center !important;
  align-items: center !important;
  min-width: fit-content !important;
  cursor: pointer;
}

.particularCategoryContainer .particularCustomerDivCategory {
  padding: 8px !important;
  height: 35px !important;
}

.particularCustomerDivCategory:focus {
  background-color: #e3e8ff !important;
  color: #0562fb !important;
  border: solid 1px #0562fb !important;
}

.dark .particularCustomerDivCategory {
  background-color: var(--dark-blue);
  color: white;
}

.light .particularCustomerDivCategory {
  background-color: white;
  color: black;
}

.particularActiveCategory {
  background-color: #0562fb !important;
  color: #fff !important;
  border: solid 1px #2a71ff;
  font-weight: 700 !important;
}

.forLoader {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  height: 100% !important;
  padding: 16px !important;
}

.forLoader-cards {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  height: 100% !important;
  padding: 16px !important;
  width: 204px;
}

.forGridContainer {
  display: grid;
  grid-template-columns: 24% 75%;
  gap: 8px !important;
  overflow-y: hidden;
}

.forGridContainer-hidesidebar {
  display: grid;
  grid-template-columns: 0% 100%;
  /* gap: 8px !important; */
  overflow-y: hidden;
}

.forGridItem {
  /* overflow-y: scroll; */
  overflow-x: hidden;
  /* padding-bottom: 114px; */
  container-type: inline-size;
  container-name: prod-panel;
}

.productListInnerContainer {
  display: grid;
  position: relative;
  grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
  grid-auto-rows: minmax(90px, auto);
  gap: 8px;
  padding: 4px 4px 114px;
  align-content: start;
  overflow-x: hidden;
  width: 100%;
  box-sizing: border-box;
}

.productListInnerContainer-flex-row-wrap {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(155px, 1fr));
  gap: 12px;
  padding-bottom: 135px;
  position: relative;
}

.product-card-skeleton {
  min-height: 242px;
  padding: 14px;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #fff;
  overflow: hidden;
}

.product-card-skeleton--rowViewLayout,
.product-card-skeleton--listViewLayout {
  min-height: 96px;
}

.product-card-skeleton__image,
.product-card-skeleton__line,
.product-card-skeleton__dot,
.product-card-skeleton__price,
.product-card-skeleton__btn {
  background: linear-gradient(90deg, #f1f3f6 25%, #e5e9ef 50%, #f1f3f6 75%);
  background-size: 200% 100%;
  animation: product-skeleton-shimmer 1.2s ease-in-out infinite;
}

.product-card-skeleton__image {
  height: 112px;
  margin-bottom: 14px;
  border-radius: 10px;
}

.product-card-skeleton__line {
  height: 12px;
  margin-bottom: 9px;
  border-radius: 999px;
}

/* Title row: title bar + a small veg/non-veg square, like the real card */
.product-card-skeleton__title-row {
  display: flex;
  align-items: center;
  gap: 6px;
}

.product-card-skeleton__title-row .product-card-skeleton__line--title {
  flex: 1;
  margin-bottom: 9px;
}

.product-card-skeleton__line--title {
  width: 78%;
}

.product-card-skeleton__line--short {
  width: 42%;
}

.product-card-skeleton__dot {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
  border-radius: 3px;
  align-self: flex-start;
}

/* Footer row: price block on the left, "Add +" pill on the right */
.product-card-skeleton__footer-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 18px;
}

.product-card-skeleton__price {
  width: 56px;
  height: 18px;
  border-radius: 6px;
}

.product-card-skeleton__btn {
  width: 64px;
  height: 30px;
  border-radius: 999px;
}

.product-card-skeleton--rowViewLayout .product-card-skeleton__image,
.product-card-skeleton--listViewLayout .product-card-skeleton__image {
  float: left;
  width: 72px;
  height: 68px;
  margin: 0 14px 0 0;
}

.product-card-skeleton--rowViewLayout .product-card-skeleton__body,
.product-card-skeleton--listViewLayout .product-card-skeleton__body {
  overflow: hidden;
}

.product-refresh-indicator {
  position: absolute;
  z-index: 4;
  top: 0;
  left: 0;
  width: 35%;
  height: 3px;
  border-radius: 999px;
  background: #0860e6;
  animation: product-refresh-slide 1s ease-in-out infinite alternate;
}

/* ── Empty state (no products in selected category/filter) ── */
.pos-empty-state {
  grid-column: 1 / -1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
  min-height: 320px;
  padding: 48px 24px;
  box-sizing: border-box;
}

.pos-empty-state__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 92px;
  height: 92px;
  margin-bottom: 20px;
  border-radius: 50%;
  color: #0860e6;
  background: #eef4ff;
}

.pos-empty-state__icon svg {
  width: 42px;
  height: 42px;
}

.pos-empty-state__title {
  margin: 0 0 8px;
  font-size: 1.05rem;
  font-weight: 700;
  color: #1f2937;
}

.pos-empty-state__subtitle {
  margin: 0;
  max-width: 320px;
  font-size: 0.85rem;
  font-weight: 400;
  line-height: 1.5;
  color: #6b7280;
}

.pos-empty-state.dark .pos-empty-state__icon {
  color: #93b4ff;
  background: rgba(8, 96, 230, 0.18);
}

.pos-empty-state.dark .pos-empty-state__title {
  color: #f1f5f9;
}

.pos-empty-state.dark .pos-empty-state__subtitle {
  color: #94a3b8;
}

@keyframes product-skeleton-shimmer {
  from {
    background-position: 200% 0;
  }
  to {
    background-position: -200% 0;
  }
}

@keyframes product-refresh-slide {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(185%);
  }
}

/* ── List view layout (horizontal rows) ── */
.productListInnerContainer-list {
  display: flex;
  position: relative;
  flex-direction: column;
  gap: 8px;
  padding: 4px 4px 135px;
  width: 100%;
  box-sizing: border-box;
}

.productListInnerContainer-list .particularCategoryEachItemCFS {
  width: 100%;
}

.productListInnerContainer-list .loaderAndContent {
  width: 100%;
}

/* Container queries — respond to the panel's own width, not the viewport */
@container prod-panel (min-width: 480px) {
  .productListInnerContainer-flex-row-wrap {
    grid-template-columns: repeat(3, 1fr);
  }
}
@container prod-panel (min-width: 300px) and (max-width: 479px) {
  .productListInnerContainer-flex-row-wrap {
    grid-template-columns: repeat(2, 1fr);
  }
}
@container prod-panel (max-width: 299px) {
  .productListInnerContainer-flex-row-wrap {
    grid-template-columns: repeat(1, 1fr);
  }
}

.add-item-btn {
  cursor: pointer;
  background-color: #0562fb;
  color: #fff;
  border: solid 1px #5271ff;
  font-weight: bold;
  font-size: 1.2rem;
  border-radius: 50%;
  width: 30px;
  height: 30px;
}

.add-item-btn:focus {
  background-color: #e3e8ff !important;
  color: #0562fb !important;
  border: solid 1px #0562fb !important;
  outline: none;
}

.activeCategory {
  /* background-color: #0562fb !important; */
  color: #fff !important;
  /* border: solid 1px #2b2f42; */
  font-weight: 700 !important;
}

.qrScanner {
  width: 60% !important;
  height: 25vh !important;
}

.paymentBox {
  display: flex;
  justify-content: space-between;
  font-size: 0.9rem;
}

.hrLine {
  margin-top: 4vh;
}

.paymentmethod {
  font-size: 0.9rem;
}

.holdOrderBtn {
  width: 45%;
  height: 5vh;
  background-color: #e79837 !important;
  border-radius: 20px;
  color: white;
  margin-top: 2vh;
  border: none;
  cursor: pointer;
  margin-right: 10%;
}

.CreditCardIcon {
  display: flex;
  justify-content: space-between;
}

.systemHealthText {
  font-size: 1rem;
  color: white;
  margin-bottom: 0px;
}

.particularElementName {
  text-transform: uppercase !important;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 700;
}

.systemHealthIcons {
  color: green !important;
  height: 10vh !important;
  width: 8% !important;
  margin-right: 10px;
}

.mrp-option-wrapper-box {
  padding: 20px !important;
}

.select-mrp-wrapper-box {
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 15px;
  margin-bottom: 10px;
  margin-top: 10px;
  border-radius: 7px;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}

.mrp-popup-box {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: sticky;
  bottom: 0;
  background-color: white;
  padding: 0px 20px 10px 20px;
}

.dark .mrp-popup-box {
  background-color: var(--dark-blue);
}

.mrp-btn {
  width: 30%;
  height: 2rem;
  background-color: #0562fb !important;
  border-radius: 12px;
  color: white;
  margin-top: 1vh;
  border: none;
  font-weight: bold;
  float: right;
  cursor: pointer;
  box-shadow: #0562fb 0px 3px 5px -2px !important;
  letter-spacing: 1px;
  margin-bottom: 1vh !important;
}

.mrp-btn:disabled {
  opacity: 0.3;
}

.mrp-cancel-btn {
  width: 30%;
  height: 2rem;
  background-color: #0562fb !important;
  border-radius: 12px;
  color: white;
  margin-top: 1vh;
  border: none;
  font-weight: bold;
  float: right;
  cursor: pointer;
  box-shadow: #0562fb 0px 3px 5px -2px !important;
  letter-spacing: 1px;
  margin-bottom: 1vh !important;
  margin-right: 20px !important;
}

.addCustomericonsDiv {
  font-size: 1rem;
  margin-bottom: 2vh;
  text-align: center;
}

.fixedPosition {
  margin-top: 10vh !important;
}

.adjustOrderBox {
  display: flex;
}

.adjustOrderBox p {
  padding: 2px;
  background-color: red;
  text-align: center;
  align-content: center !important;
  align-items: center !important;
}

.dark .systemHealthText {
  color: white;
}

.light .systemHealthText {
  color: black !important;
}

@media screen and (max-width: 900px) {
  /* .categoryText {
    display: none !important;
  } */
  /* .customerContainer {
    display: none !important;
  } */

  .fixedPosition {
    display: none;
  }
}

@media screen and (min-width: 900px) {
  .fixedPosition1 {
    display: none !important;
  }
}

.fixedPosition1 {
  margin-top: 5vh !important;
}

.systemHealthText1 {
  font-size: 1rem;
  margin-bottom: 0px;
}

.dark .systemHealthText1 {
  color: white;
}

.light .systemHealthText1 {
  color: black;
}

.systemHealthIcons1 {
  color: green !important;
  height: 5vh !important;
  width: 8% !important;
  margin-right: 10px;
}

.number {
  color: #0562fb;
  font-weight: 700 !important;
  font-size: 15px;
}

.weight-wrapper-box {
  display: flex;
  margin-left: 6px;
  font-size: 0.7em;
  font-weight: 600;
  color: #0562fb;
  gap: 5px;
}

.no-data-wrapper-text {
  font-size: 1.5rem;
  letter-spacing: 0.25em;
  font-weight: 600;
  color: #353a50;
}

.dark .no-data-wrapper-text {
  color: #fff !important;
}

.gtin-wrapper-box {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 100%;
}

.load-more-text-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.load-more-text-wrapper-btn {
  padding: 5px;
  background-color: transparent;
  color: #0562fb !important;
  border: none;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  border: 1px solid lightblue;
  text-align: center;
  border-radius: 3px;
}

.custom-error-modal-wrapper {
  padding: 1rem !important;
  max-width: 100vw;
  max-height: 90%;
  transform: translate(50%, -50%);
  border-radius: 10px;
  top: 50%;
  left: 15%;
  overflow-y: auto;
  transition:
    max-height 0.8s ease-in-out,
    padding 0.8s ease-in-out;
  outline: none !important;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  border: 1px solid lightblue;
}

.custom-error-modal-wrapper.show-solution {
  max-height: 100%;
}

.error-custom-text {
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
  color: red;
}

.solution-error-custom-text {
  font-size: 1rem;
  margin-bottom: 1rem;
  color: #0562fb;
}

.custom-error-ui {
  list-style-type: none;
  padding: 0;
}

.custom-error-ui li {
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
}

.custom-error-btn {
  background-color: #0562fb;
  color: #fff;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1rem;
  transition: background-color 0.3s;
}

@media only screen and (max-width: 720px) {
  .forGridContainer {
    display: grid;
    grid-template-columns: 1fr;
  }
}

/************ Redesigning Cart ***************/

.particularCategoryContainerWrapper {
  display: flex;
  align-items: center;
  gap: 18px;
}

.searchbarContainer {
  padding: 0px 0px 10px 0px;
  background: #f8fafc !important;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  overflow-x: auto;
  flex-wrap: nowrap;
  scrollbar-width: none;
}

.searchbarContainer::-webkit-scrollbar {
  display: none;
}

.searchbarContainer.dark {
  background-color: var(--dark-blue) !important;
}

.centerItems {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.customHeaderContainer {
  /* padding: 10px !important; */
}

.customHeaderContainer.dark {
  background-color: var(--dark-blue);
}

.customSearchBar-div {
  width: 100%;
}

.arrowPathRoundedSquareIcon {
  display: flex;
  padding: 2px 4px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border-radius: 4px;
  background: #fff;
}

.newSearchContainer {
  display: flex;
  min-height: 40px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  width: 100%;
  flex-wrap: wrap;
  gap: 10px;
  padding: 10px 5px;
  border-top: 1.5px solid #e2e8f0;
  border-bottom: 1.5px solid #e2e8f0;
  background: #f8fafc;
}

.newSearchContainerLeftSection {
  display: flex;
  align-items: center;
  gap: 12px;
  align-self: stretch;
  flex: 1;
  min-width: 0;
}

.productLayoutTypes-rightSection {
  display: flex;
  align-items: center;
  gap: 4px;
}

.productLayoutTypes-row-view {
  box-sizing: border-box;
  display: flex;
  width: 36px;
  height: 36px;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  cursor: pointer;
  transition: background 0.15s;
}

.productLayoutTypes-active-btn {
  background: #0860e6;
  color: #fff;
}

.productLayoutTypes-inactive-btn {
  background: transparent;
  color: #6b7280;
}

.add-product-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  height: 40px;
  padding: 0 14px;
  border: 1px solid #0860e6;
  border-radius: 6px;
  background: #fff;
}

.productLayoutTypes-active-border {
  border: 1px solid #0860e6;
}

.productLayoutTypes-inactive-btn {
  background: transparent;
  color: #6b7280;
}

.add-product-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  height: 40px;
  padding: 0 14px;
  border: 1px solid #0860e6;
  border-radius: 6px;
  background: #0860e6;
  color: #ffffff;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition:
    background 0.15s,
    border-color 0.15s;
  font-family: inherit;
}

.add-product-btn:hover {
  background: #0752c4;
  border-color: #0752c4;
}

.productLayoutTypes-inactive-btn:hover {
  background: #f3f4f6;
  color: #374151;
}
/**********************************************/

@media (min-width: 1020px) {
  .customSearchBar-div {
    width: 364px;
  }
}

/* ═══════════════════════════════════════════
   Static 3-Panel Layout
   ═══════════════════════════════════════════ */

.pcp-outer {
  display: flex !important;
  flex-direction: column !important;
  height: calc(100vh - 56px) !important;
  overflow: hidden;
}

.pcp-layout {
  display: flex;
  flex-direction: row;
  flex: 1;
  width: 100%;
  overflow: hidden;
  gap: 0;
  /* padding-top: 6px;
  margin-top: 10px; */
  background-color: #fff;
}

/* ── Categories Panel ── */
.pcp-category-panel {
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  min-width: 0;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

/* Static panel layout */
/* ── Products Panel ── */
/* ── Cart Panel ── */
/* Override rightContainer for non-Grid context */
.pcp-cart-panel .rightContainer {
  height: 100% !important;
  display: flex !important;
  flex-direction: column !important;
}

/* Ensure product grid fills remaining space in products panel */
.pcp-products-panel .particularCategoryEachItemGridContainerCFSCartPage {
  flex: 1;
  height: 0; /* flex trick to fill remaining space */
  min-height: 0;
}

/* Search bar stretches to fill available space in products panel */
.pcp-products-panel .customSearchBar-div {
  width: 100%;
}

/* ═══════════════════════════════════════════
   Static 3-Panel Layout
   ═══════════════════════════════════════════ */

.pcp-outer {
  display: flex !important;
  flex-direction: column !important;
  height: calc(100vh - 56px) !important;
  overflow: hidden;
}

.pcp-layout {
  display: flex;
  flex-direction: row;
  flex: 1;
  width: 100%;
  overflow: hidden;
  gap: 0;
  padding: 0;
  background: #eef0f4;
}

/* ── Categories Panel ── */
.pcp-category-panel {
  background: #ffffff;
  border-radius: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  min-width: 0;
  box-shadow: none;
  border-right: 1px solid #e2e8f0;
}

.pcp-resizer {
  position: relative;
  display: flex;
  width: 1px;
  align-items: center;
  justify-content: center;
  background-color: #e2e8f0;
  cursor: col-resize;
  flex-shrink: 0;
  z-index: 10;
  transition: background-color 0.15s ease;
}

.dark .pcp-resizer {
  background-color: #334155;
}

/* Wider grab area overlay */
.pcp-resizer::after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 50%;
  width: 8px;
  transform: translateX(-50%);
  cursor: col-resize;
}


.pcp-resizer-handle {
  z-index: 10;
  display: flex;
  height: 16px;
  width: 12px;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  border: 1px solid #cbd5e1;
  background-color: #f8fafc;
  color: #64748b;
  cursor: col-resize;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.15s ease;
}

.dark .pcp-resizer-handle {
  border-color: #475569;
  background-color: #1e293b;
  color: #94a3b8;
}

.pcp-resizer:hover .pcp-resizer-handle,
.pcp-resizer:active .pcp-resizer-handle {
  border-color: #0860e6;
  background-color: #0860e6;
  color: #ffffff;
}

.dark .pcp-resizer:hover .pcp-resizer-handle,
.dark .pcp-resizer:active .pcp-resizer-handle {
  border-color: #3b82f6;
  background-color: #3b82f6;
  color: #ffffff;
}

.pcp-resizer-handle svg {
  width: 10px;
  height: 10px;
}

.pcp-category-heading {
  font-size: 0.7rem;
  font-weight: 800;
  color: #9ca3af;
  padding: 12px 14px 10px;
  border-bottom: 1px solid #f0f2f5;
  flex-shrink: 0;
  margin: 0;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  background: #fafbfc;
}

.pcp-category-body {
  flex: 1;
  scrollbar-width: thin;
  scrollbar-color: #d1d5db transparent;
}

.pcp-category-body::-webkit-scrollbar {
  width: 3px;
}

.pcp-category-body::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 4px;
}

/* Static panel layout */
/* ── Products Panel ── */
.pcp-products-panel {
  flex: 1;
  min-width: 200px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background: #f8fafc;
  border-radius: 0;
  border: none;
  border-right: 1px solid #e2e8f0;
  box-shadow: none;
  padding: 10px 10px 0;
}

/* ── Cart Panel ── */
.pcp-cart-panel {
  flex-shrink: 0;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border-radius: 0;
  background: #f5f8ff;
  border-left: 2px solid #c7d9f8;
  box-shadow: -4px 0 16px rgba(8, 96, 230, 0.07);
  position: relative;
}

/* Subtle top accent line on cart */
.pcp-cart-panel::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #0860e6 0%, #4f9cf9 100%);
  z-index: 1;
}

/* Override rightContainer for non-Grid context */
.pcp-cart-panel .rightContainer {
  height: 100% !important;
  display: flex !important;
  flex-direction: column !important;
}

/* Ensure product grid fills remaining space in products panel */
.pcp-products-panel .particularCategoryEachItemGridContainerCFSCartPage {
  flex: 1;
  height: 0;
  min-height: 0;
}

/* Search bar stretches to fill available space in products panel */
.pcp-products-panel .customSearchBar-div {
  width: 100%;
}

/* Filter chips row — enhanced */
.searchbarContainer {
  padding: 10px 2px !important;
  background: #f8fafc !important;
  border-bottom: 1px solid #f0f2f5;
  margin-bottom: 2px;
  gap: 6px !important;
}

/* ── Active filter chip override ── */
.pcp-products-panel .searchbarContainer button {
  box-shadow: none;
  transition: all 0.15s ease !important;
}

.pcp-products-panel .searchbarContainer button:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12) !important;
}

/* ── Dark mode for 3-panel layout ── */
.dark .pcp-layout {
  background: #0f172a;
}

.dark .pcp-category-panel {
  background: #1e293b;
  border-right-color: #334155;
}

.dark .pcp-category-heading {
  background: #162032;
  color: #64748b;
  border-bottom-color: #334155;
}

.dark .pcp-category-body {
  scrollbar-color: #475569 transparent;
}

.dark .pcp-products-panel {
  background: #0f172a;
  border-right-color: #334155;
}

.dark .searchbarContainer {
  background: #0f172a !important;
  border-bottom-color: #334155;
}

.dark .pcp-cart-panel {
  background: #111827;
  border-left-color: #1d4ed8;
}

.dark .newSearchContainer {
  background: #0f172a !important;
  border-top-color: #334155;
  border-bottom-color: #334155;
}

.dark .arrowPathRoundedSquareIcon {
  background: #1e293b;
}

.dark .product-card-skeleton {
  background: #1e293b;
  border-color: #334155;
}

.dark .product-card-skeleton__image,
.dark .product-card-skeleton__line,
.dark .product-card-skeleton__dot,
.dark .product-card-skeleton__price,
.dark .product-card-skeleton__btn {
  background: linear-gradient(90deg, #1e293b 25%, #334155 50%, #1e293b 75%);
  background-size: 200% 100%;
}

.dark .particularCategoryEachItemGridContainerCFSCartPage {
  scrollbar-color: #334155 transparent;
}

.dark .particularCategoryEachItemGridContainerCFSCartPage::-webkit-scrollbar-thumb {
  background: #334155 !important;
}

/* Restaurant POS layout refinements */
@media (min-width: 1024px) and (max-width: 1100px) {
  .pcp-products-panel {
    padding: 8px 8px 0;
  }

  .searchbarContainer {
    gap: 5px !important;
    padding: 8px 0 !important;
  }

  .pcp-products-panel .searchbarContainer button {
    padding: 8px 12px !important;
    font-size: 0.74rem !important;
  }

  .newSearchContainer {
    gap: 8px;
    padding: 8px 4px;
  }

  .productListInnerContainer-flex-row-wrap {
    align-content: start;
    gap: 10px;
    overflow-x: hidden;
    padding-bottom: 120px;
  }

  .particularCategoryEachItemCFS {
    padding: 2px;
  }
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/ProductsPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,yBAAyB;EACzB,OAAO;EACP,0BAA0B;EAC1B,6BAA6B;EAC7B,wBAAwB;EACxB,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,aAAa;EACb,8BAA8B;EAC9B,6BAA6B;EAC7B,6BAA6B;EAC7B,2BAA2B;EAC3B,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA,+BAA+B;AAC/B;EACE;8BAC4B;EAC5B,OAAO;EACP,0BAA0B;EAC1B,6BAA6B;EAC7B,6BAA6B;EAC7B,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,2BAA2B;EAC3B,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;AACA;EACE,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,2BAA2B;EAC3B,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,8CAA8C;EAC9C,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA,aAAa;;AAEb;EACE,oDAAoD;EACpD,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,oDAAoD;EACpD,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,iBAAiB;;EAEjB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA,qCAAqC;;AAErC;EACE,aAAa;EACb,2BAA2B;EAC3B,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,oDAAoD;EACpD,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,oDAAoD;EACpD,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,sBAAsB;EACtB,gBAAgB;EAChB,8BAA8B;EAC9B,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;EAC3B,eAAe;EACf,aAAa;EACb,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA,cAAc;;AAEd,qCAAqC;;AAErC;EACE,aAAa;EACb,2BAA2B;EAC3B,2BAA2B;EAC3B,mBAAmB;EACnB,qBAAqB;EACrB,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,oDAAoD;EACpD,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,oDAAoD;EACpD,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,2BAA2B;EAC3B,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,6BAA6B;EAC7B,8BAA8B;EAC9B,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,8BAA8B;EAC9B,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,8BAA8B;EAC9B,uBAAuB;EACvB,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,2BAA2B;EAC3B,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,4DAA4D;EAC5D,kCAAkC;EAClC,QAAQ;EACR,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;;;;EAKE,yEAAyE;EACzE,0BAA0B;EAC1B,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,0EAA0E;AAC1E;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,OAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;;EAEE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,OAAO;EACP,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,kEAAkE;AACpE;;AAEA,gEAAgE;AAChE;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,QAAQ;EACR,sBAAsB;EACtB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA,2EAA2E;AAC3E;EACE;IACE,qCAAqC;EACvC;AACF;AACA;EACE;IACE,qCAAqC;EACvC;AACF;AACA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,oCAAoC;EACpC,aAAa;AACf;;AAEA;EACE,0CAA0C;EAC1C,sBAAsB;EACtB,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oCAAoC;EACpC,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,+CAA+C;EAC/C,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,+CAA+C;EAC/C,mBAAmB;EACnB,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;;KAEG;EACH;;KAEG;;EAEH;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB;;4BAE0B;EAC1B,wBAAwB;EACxB,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE;IACE,aAAa;IACb,0BAA0B;EAC5B;AACF;;AAEA,8CAA8C;;AAE9C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,+BAA+B;EAC/B,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,OAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB;;sBAEoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA,+CAA+C;;AAE/C;EACE;IACE,YAAY;EACd;AACF;;AAEA;;gDAEgD;;AAEhD;EACE,wBAAwB;EACxB,iCAAiC;EACjC,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,OAAO;EACP,WAAW;EACX,gBAAgB;EAChB,MAAM;EACN;qBACmB;EACnB,sBAAsB;AACxB;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,YAAY;EACZ,yCAAyC;AAC3C;;AAEA,wBAAwB;AACxB,yBAAyB;AACzB,qBAAqB;AACrB,iDAAiD;AACjD;EACE,uBAAuB;EACvB,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA,gEAAgE;AAChE;EACE,OAAO;EACP,SAAS,EAAE,uCAAuC;EAClD,aAAa;AACf;;AAEA,mEAAmE;AACnE;EACE,WAAW;AACb;;AAEA;;gDAEgD;;AAEhD;EACE,wBAAwB;EACxB,iCAAiC;EACjC,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,OAAO;EACP,WAAW;EACX,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,SAAS;EACT,UAAU;EACV,2BAA2B;EAC3B,kBAAkB;AACpB;;;AAGA;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,2CAA2C;EAC3C,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,gCAAgC;EAChC,cAAc;EACd,SAAS;EACT,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB,yBAAyB;AACzB;EACE,OAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,qBAAqB;AACrB;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,8CAA8C;EAC9C,kBAAkB;AACpB;;AAEA,mCAAmC;AACnC;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,4DAA4D;EAC5D,UAAU;AACZ;;AAEA,iDAAiD;AACjD;EACE,uBAAuB;EACvB,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA,gEAAgE;AAChE;EACE,OAAO;EACP,SAAS;EACT,aAAa;AACf;;AAEA,mEAAmE;AACnE;EACE,WAAW;AACb;;AAEA,gCAAgC;AAChC;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,sCAAsC;AACtC;EACE,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;EAC3B,oDAAoD;AACtD;;AAEA,uCAAuC;AACvC;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;;;;EAKE,yEAAyE;EACzE,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;AAChC;;AAEA,sCAAsC;AACtC;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,4BAA4B;IAC5B,6BAA6B;EAC/B;;EAEA;IACE,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IACpB,SAAS;IACT,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,YAAY;EACd;AACF","sourcesContent":[".particularCategoryEachItemGridContainer {\n  display: flex;\n  align-content: flex-start;\n  flex: 1;\n  flex-wrap: wrap !important;\n  overflow-y: scroll !important;\n  padding: 14px !important;\n  border-radius: 4px;\n  border: 0.2px solid #bcbcbc;\n  margin-right: 10px;\n  box-shadow: 4px 4px 4px 0px #00000040 !important;\n}\n\n.particularCategoryEachItem {\n  width: 146px !important;\n  margin-right: 6px !important;\n  height: 150px;\n  padding-bottom: 1vh !important;\n  border-radius: 5px !important;\n  margin-bottom: 2vh !important;\n  border: 0.2px solid #bcbcbc;\n  box-shadow: 4px 4px 4px #00000040;\n  min-width: 10rem;\n  text-align: center;\n  padding: 4px;\n  background-color: #fff;\n}\n\n.particularCategoryEachItemImgContainer {\n  width: 100%;\n  height: 100px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  margin-bottom: 10px;\n  position: relative;\n}\n\n.particularCategoryEachItemImg {\n  width: 100% !important;\n  height: 100px !important;\n  object-fit: cover !important;\n  border-radius: 5px !important;\n}\n\n/* For Catefory Products view */\n.particularCategoryEachItemGridContainerCFSCartPage {\n  /* display: grid;\n  align-content: flex-start; */\n  flex: 1;\n  flex-wrap: wrap !important;\n  overflow-y: scroll !important;\n  overflow-x: hidden !important;\n  height: 100% !important;\n  padding-top: 10px !important;\n  border-radius: 4px;\n  /* scrollbar-width: thin; */\n  scrollbar-color: #a0aec0 transparent;\n  padding-right: 6px;\n}\n\n.particularCategoryEachItemGridContainerCFSCartPage::-webkit-scrollbar {\n  width: 6px !important;\n}\n.particularCategoryEachItemGridContainerCFSCartPage::-webkit-scrollbar-thumb {\n  background: #a0aec0 !important;\n  border-radius: 4px !important;\n}\n.particularCategoryEachItemGridContainerCFSCartPage::-webkit-scrollbar-track {\n  background: transparent !important;\n}\n\n.particularCategoryEachItemCFS {\n  width: 100% !important;\n  min-width: 0 !important;\n  border-radius: 12px !important;\n  margin-bottom: 0 !important;\n  border: none;\n  background-color: transparent;\n  overflow: hidden;\n  padding: 3px;\n  box-sizing: border-box;\n}\n\n.particularCategoryEachItemCFS.dark {\n  border: none !important;\n}\n\n.particularCategoryEachItemCFS.keyboard-focused {\n  border: 2px solid #3b82f6 !important;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.25);\n  background-color: #eff6ff !important;\n}\n\n.particularCategoryEachItemImgContainerCFS {\n  width: 100%;\n  height: 120px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  margin-bottom: 10px;\n  position: relative;\n}\n\n.particularCategoryEachItemImgCFS {\n  width: 100%;\n  height: 120px;\n  object-fit: cover;\n  border-radius: 5px !important;\n}\n\n.foodTypeIcon {\n  height: 14px;\n  width: 14px;\n  position: absolute;\n  left: 88%;\n  bottom: 82%;\n}\n\n.particularElementNameContainerCFS {\n  display: flex;\n  justify-content: space-between;\n  align-items: center !important;\n}\n\n.particularElementNameCFS {\n  text-transform: uppercase !important;\n  font-weight: 700;\n  word-wrap: break-word;\n  white-space: normal;\n  overflow-wrap: break-word;\n  max-width: 110px;\n  line-height: 1.1;\n}\n\n.particularElementNameCFSPrice {\n  font-size: 0.75rem;\n  font-weight: 700;\n  color: #2a71ff;\n}\n/* Til Here */\n\n.particularCategoryEachItemGridContainer::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.3);\n  border-radius: 10px;\n  background-color: #f5f5f5;\n}\n\n.particularCategoryEachItemGridContainer::-webkit-scrollbar {\n  width: 3px;\n  height: 3px;\n  background-color: #f5f5f5;\n}\n\n.particularCategoryEachItemGridContainer::-webkit-scrollbar-thumb {\n  border-radius: 10px;\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n  background-color: #cbcbcb;\n}\n\n.dark .particularCategoryEachItem {\n  background-color: #353a50 !important;\n  color: white !important;\n}\n\n.light .particularCategoryEachItem {\n  background-color: white !important;\n  color: black !important;\n}\n\n.drawerCloseIcon {\n  cursor: pointer;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.drawerCloseIcon ::selection {\n  color: #7ed957;\n}\n\n.closePopCrossIcon {\n  color: white !important;\n}\n\n.popUpInput {\n  padding: 5px !important;\n  border-radius: 6px !important;\n  width: 100%;\n  margin-bottom: 20px !important;\n}\n\n.popUpVerifyBtn {\n  margin-left: 8%;\n  font-size: medium;\n\n  border: none !important;\n  color: #7ed957;\n  cursor: pointer;\n}\n\n.popUpVerifyBtn1 {\n  margin-left: 8%;\n  font-size: medium;\n  color: white;\n  cursor: pointer;\n}\n\n.skipBtnContainer {\n  display: flex !important;\n  width: 100% !important;\n}\n\n.skipNowbtn {\n  cursor: pointer !important;\n}\n\n.particular-cat-container {\n  background-color: #eef0f4;\n  padding-left: 4px;\n  padding-right: 0;\n  height: 98%;\n  margin-top: 50px;\n  width: 100% !important;\n}\n\n.particular-cat-container-inner {\n  height: 100vh;\n}\n\n@media (max-width: 576px) {\n  .particular-cat-container {\n    padding: 0.5rem;\n  }\n}\n\n.dark .particular-cat-container {\n  background-color: #2b2f42;\n}\n\n.leftContainer {\n  padding-right: 5px;\n  /* border: 0.5px solid #bcbcbc; */\n  overflow: hidden;\n  position: relative;\n  border-radius: 2px;\n  /* padding: 10px; */\n  /* background-color: #fff; */\n  height: 100% !important;\n}\n\n.select-items-container {\n  display: flex;\n  flex-direction: column;\n  min-width: 40%;\n}\n\n.select-item-details {\n  color: gray;\n  font-size: 1rem;\n  font-weight: bold;\n}\n\n.addCustomericonsDiv {\n  display: flex;\n  align-content: center;\n  color: white;\n}\n\n.subContainer {\n  width: 100%;\n}\n\n.inputText {\n  width: 100%;\n  border-radius: 20px;\n  border: 1px solid black;\n  padding: 7px 0px;\n  padding-left: 2vw;\n  height: 5vh;\n  margin-bottom: 1vh;\n}\n\n.categoryText {\n  display: flex;\n  justify-content: flex-start !important;\n  color: white;\n  margin-top: 2vh !important;\n  margin-bottom: 1vh;\n}\n\n.categoryText h4 {\n  font-size: 1.5rem;\n}\n\n.dark .categoryText {\n  color: white;\n}\n\n.light .categoryText {\n  color: black;\n}\n\n.customers {\n  margin-top: 5vh;\n  margin-bottom: 1vh;\n  font-size: 1rem;\n}\n\n.dark .customers {\n  color: white;\n}\n\n.light .customers {\n  color: black;\n}\n\n/* Old Particular Categories styles */\n\n.categoryContainer {\n  display: flex;\n  justify-content: flex-start;\n  overflow-x: auto !important;\n  margin-bottom: 1rem;\n}\n\n.categoryContainer::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.3);\n  border-radius: 10px;\n  background-color: #f5f5f5;\n}\n\n.categoryContainer::-webkit-scrollbar {\n  width: 3px;\n  height: 3px;\n  background-color: #f5f5f5;\n}\n\n.categoryContainer::-webkit-scrollbar-thumb {\n  border-radius: 10px;\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n  background-color: #cbcbcb;\n}\n\n.light .customerDivParticularCategory:focus {\n  outline: none;\n}\n\n.dark .customerDivParticularCategory:focus {\n  outline: none;\n}\n\n.customerDivParticularCategory {\n  border-radius: 5px;\n  min-width: fit-content !important;\n  height: 5vh !important;\n  margin-right: 5%;\n  align-items: center !important;\n  text-align: center !important;\n  font-size: 1rem !important;\n  font-weight: 400 !important;\n  cursor: pointer;\n  display: flex;\n  border: 1px solid #2a71ff;\n  color: #2a71ff !important;\n}\n\n.categoryContainer .customerDivParticularCategory {\n  padding: 8px !important;\n  height: 44px !important;\n}\n\n.customerDivParticularCategory:focus {\n  background-color: #e3e8ff !important;\n  color: #0562fb !important;\n  border: solid 1px #0562fb !important;\n}\n\n.dark .customerDivParticularCategory {\n  background-color: var(--dark-blue);\n  color: white;\n}\n\n.light .customerDivParticularCategory {\n  background-color: white;\n  color: black;\n}\n\n/* Till Hear */\n\n/* New Particular Categories styles */\n\n.particularCategoryContainer {\n  display: flex;\n  justify-content: flex-start;\n  overflow-x: auto !important;\n  gap: 7px !important;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n  width: 100%;\n}\n\n.particularCategoryContainer::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.3);\n  border-radius: 10px;\n  background-color: #f5f5f5;\n}\n\n.particularCategoryContainer::-webkit-scrollbar {\n  display: none;\n}\n\n.particularCategoryContainer::-webkit-scrollbar-thumb {\n  border-radius: 10px;\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n  background-color: #cbcbcb;\n}\n\n.light .particularCustomerDivCategory:focus {\n  outline: none;\n}\n\n.dark .particularCustomerDivCategory:focus {\n  outline: none;\n}\n\n.particularCustomerDivCategory {\n  border-radius: 5px;\n  font-size: 0.813rem !important;\n  font-weight: 400 !important;\n  border: 1px solid #2a71ff;\n  color: #2a71ff !important;\n  display: flex;\n  text-align: center !important;\n  align-items: center !important;\n  min-width: fit-content !important;\n  cursor: pointer;\n}\n\n.particularCategoryContainer .particularCustomerDivCategory {\n  padding: 8px !important;\n  height: 35px !important;\n}\n\n.particularCustomerDivCategory:focus {\n  background-color: #e3e8ff !important;\n  color: #0562fb !important;\n  border: solid 1px #0562fb !important;\n}\n\n.dark .particularCustomerDivCategory {\n  background-color: var(--dark-blue);\n  color: white;\n}\n\n.light .particularCustomerDivCategory {\n  background-color: white;\n  color: black;\n}\n\n.particularActiveCategory {\n  background-color: #0562fb !important;\n  color: #fff !important;\n  border: solid 1px #2a71ff;\n  font-weight: 700 !important;\n}\n\n.forLoader {\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n  height: 100% !important;\n  padding: 16px !important;\n}\n\n.forLoader-cards {\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n  height: 100% !important;\n  padding: 16px !important;\n  width: 204px;\n}\n\n.forGridContainer {\n  display: grid;\n  grid-template-columns: 24% 75%;\n  gap: 8px !important;\n  overflow-y: hidden;\n}\n\n.forGridContainer-hidesidebar {\n  display: grid;\n  grid-template-columns: 0% 100%;\n  /* gap: 8px !important; */\n  overflow-y: hidden;\n}\n\n.forGridItem {\n  /* overflow-y: scroll; */\n  overflow-x: hidden;\n  /* padding-bottom: 114px; */\n  container-type: inline-size;\n  container-name: prod-panel;\n}\n\n.productListInnerContainer {\n  display: grid;\n  position: relative;\n  grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));\n  grid-auto-rows: minmax(90px, auto);\n  gap: 8px;\n  padding: 4px 4px 114px;\n  align-content: start;\n  overflow-x: hidden;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.productListInnerContainer-flex-row-wrap {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(155px, 1fr));\n  gap: 12px;\n  padding-bottom: 135px;\n  position: relative;\n}\n\n.product-card-skeleton {\n  min-height: 242px;\n  padding: 14px;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  background: #fff;\n  overflow: hidden;\n}\n\n.product-card-skeleton--rowViewLayout,\n.product-card-skeleton--listViewLayout {\n  min-height: 96px;\n}\n\n.product-card-skeleton__image,\n.product-card-skeleton__line,\n.product-card-skeleton__dot,\n.product-card-skeleton__price,\n.product-card-skeleton__btn {\n  background: linear-gradient(90deg, #f1f3f6 25%, #e5e9ef 50%, #f1f3f6 75%);\n  background-size: 200% 100%;\n  animation: product-skeleton-shimmer 1.2s ease-in-out infinite;\n}\n\n.product-card-skeleton__image {\n  height: 112px;\n  margin-bottom: 14px;\n  border-radius: 10px;\n}\n\n.product-card-skeleton__line {\n  height: 12px;\n  margin-bottom: 9px;\n  border-radius: 999px;\n}\n\n/* Title row: title bar + a small veg/non-veg square, like the real card */\n.product-card-skeleton__title-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.product-card-skeleton__title-row .product-card-skeleton__line--title {\n  flex: 1;\n  margin-bottom: 9px;\n}\n\n.product-card-skeleton__line--title {\n  width: 78%;\n}\n\n.product-card-skeleton__line--short {\n  width: 42%;\n}\n\n.product-card-skeleton__dot {\n  width: 14px;\n  height: 14px;\n  flex-shrink: 0;\n  border-radius: 3px;\n  align-self: flex-start;\n}\n\n/* Footer row: price block on the left, \"Add +\" pill on the right */\n.product-card-skeleton__footer-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 18px;\n}\n\n.product-card-skeleton__price {\n  width: 56px;\n  height: 18px;\n  border-radius: 6px;\n}\n\n.product-card-skeleton__btn {\n  width: 64px;\n  height: 30px;\n  border-radius: 999px;\n}\n\n.product-card-skeleton--rowViewLayout .product-card-skeleton__image,\n.product-card-skeleton--listViewLayout .product-card-skeleton__image {\n  float: left;\n  width: 72px;\n  height: 68px;\n  margin: 0 14px 0 0;\n}\n\n.product-card-skeleton--rowViewLayout .product-card-skeleton__body,\n.product-card-skeleton--listViewLayout .product-card-skeleton__body {\n  overflow: hidden;\n}\n\n.product-refresh-indicator {\n  position: absolute;\n  z-index: 4;\n  top: 0;\n  left: 0;\n  width: 35%;\n  height: 3px;\n  border-radius: 999px;\n  background: #0860e6;\n  animation: product-refresh-slide 1s ease-in-out infinite alternate;\n}\n\n/* ── Empty state (no products in selected category/filter) ── */\n.pos-empty-state {\n  grid-column: 1 / -1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  width: 100%;\n  min-height: 320px;\n  padding: 48px 24px;\n  box-sizing: border-box;\n}\n\n.pos-empty-state__icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 92px;\n  height: 92px;\n  margin-bottom: 20px;\n  border-radius: 50%;\n  color: #0860e6;\n  background: #eef4ff;\n}\n\n.pos-empty-state__icon svg {\n  width: 42px;\n  height: 42px;\n}\n\n.pos-empty-state__title {\n  margin: 0 0 8px;\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: #1f2937;\n}\n\n.pos-empty-state__subtitle {\n  margin: 0;\n  max-width: 320px;\n  font-size: 0.85rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #6b7280;\n}\n\n.pos-empty-state.dark .pos-empty-state__icon {\n  color: #93b4ff;\n  background: rgba(8, 96, 230, 0.18);\n}\n\n.pos-empty-state.dark .pos-empty-state__title {\n  color: #f1f5f9;\n}\n\n.pos-empty-state.dark .pos-empty-state__subtitle {\n  color: #94a3b8;\n}\n\n@keyframes product-skeleton-shimmer {\n  from {\n    background-position: 200% 0;\n  }\n  to {\n    background-position: -200% 0;\n  }\n}\n\n@keyframes product-refresh-slide {\n  from {\n    transform: translateX(0);\n  }\n  to {\n    transform: translateX(185%);\n  }\n}\n\n/* ── List view layout (horizontal rows) ── */\n.productListInnerContainer-list {\n  display: flex;\n  position: relative;\n  flex-direction: column;\n  gap: 8px;\n  padding: 4px 4px 135px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.productListInnerContainer-list .particularCategoryEachItemCFS {\n  width: 100%;\n}\n\n.productListInnerContainer-list .loaderAndContent {\n  width: 100%;\n}\n\n/* Container queries — respond to the panel's own width, not the viewport */\n@container prod-panel (min-width: 480px) {\n  .productListInnerContainer-flex-row-wrap {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n@container prod-panel (min-width: 300px) and (max-width: 479px) {\n  .productListInnerContainer-flex-row-wrap {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n@container prod-panel (max-width: 299px) {\n  .productListInnerContainer-flex-row-wrap {\n    grid-template-columns: repeat(1, 1fr);\n  }\n}\n\n.add-item-btn {\n  cursor: pointer;\n  background-color: #0562fb;\n  color: #fff;\n  border: solid 1px #5271ff;\n  font-weight: bold;\n  font-size: 1.2rem;\n  border-radius: 50%;\n  width: 30px;\n  height: 30px;\n}\n\n.add-item-btn:focus {\n  background-color: #e3e8ff !important;\n  color: #0562fb !important;\n  border: solid 1px #0562fb !important;\n  outline: none;\n}\n\n.activeCategory {\n  /* background-color: #0562fb !important; */\n  color: #fff !important;\n  /* border: solid 1px #2b2f42; */\n  font-weight: 700 !important;\n}\n\n.qrScanner {\n  width: 60% !important;\n  height: 25vh !important;\n}\n\n.paymentBox {\n  display: flex;\n  justify-content: space-between;\n  font-size: 0.9rem;\n}\n\n.hrLine {\n  margin-top: 4vh;\n}\n\n.paymentmethod {\n  font-size: 0.9rem;\n}\n\n.holdOrderBtn {\n  width: 45%;\n  height: 5vh;\n  background-color: #e79837 !important;\n  border-radius: 20px;\n  color: white;\n  margin-top: 2vh;\n  border: none;\n  cursor: pointer;\n  margin-right: 10%;\n}\n\n.CreditCardIcon {\n  display: flex;\n  justify-content: space-between;\n}\n\n.systemHealthText {\n  font-size: 1rem;\n  color: white;\n  margin-bottom: 0px;\n}\n\n.particularElementName {\n  text-transform: uppercase !important;\n  width: 100%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-weight: 700;\n}\n\n.systemHealthIcons {\n  color: green !important;\n  height: 10vh !important;\n  width: 8% !important;\n  margin-right: 10px;\n}\n\n.mrp-option-wrapper-box {\n  padding: 20px !important;\n}\n\n.select-mrp-wrapper-box {\n  padding: 5px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 15px;\n  margin-bottom: 10px;\n  margin-top: 10px;\n  border-radius: 7px;\n  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\n}\n\n.mrp-popup-box {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  position: sticky;\n  bottom: 0;\n  background-color: white;\n  padding: 0px 20px 10px 20px;\n}\n\n.dark .mrp-popup-box {\n  background-color: var(--dark-blue);\n}\n\n.mrp-btn {\n  width: 30%;\n  height: 2rem;\n  background-color: #0562fb !important;\n  border-radius: 12px;\n  color: white;\n  margin-top: 1vh;\n  border: none;\n  font-weight: bold;\n  float: right;\n  cursor: pointer;\n  box-shadow: #0562fb 0px 3px 5px -2px !important;\n  letter-spacing: 1px;\n  margin-bottom: 1vh !important;\n}\n\n.mrp-btn:disabled {\n  opacity: 0.3;\n}\n\n.mrp-cancel-btn {\n  width: 30%;\n  height: 2rem;\n  background-color: #0562fb !important;\n  border-radius: 12px;\n  color: white;\n  margin-top: 1vh;\n  border: none;\n  font-weight: bold;\n  float: right;\n  cursor: pointer;\n  box-shadow: #0562fb 0px 3px 5px -2px !important;\n  letter-spacing: 1px;\n  margin-bottom: 1vh !important;\n  margin-right: 20px !important;\n}\n\n.addCustomericonsDiv {\n  font-size: 1rem;\n  margin-bottom: 2vh;\n  text-align: center;\n}\n\n.fixedPosition {\n  margin-top: 10vh !important;\n}\n\n.adjustOrderBox {\n  display: flex;\n}\n\n.adjustOrderBox p {\n  padding: 2px;\n  background-color: red;\n  text-align: center;\n  align-content: center !important;\n  align-items: center !important;\n}\n\n.dark .systemHealthText {\n  color: white;\n}\n\n.light .systemHealthText {\n  color: black !important;\n}\n\n@media screen and (max-width: 900px) {\n  /* .categoryText {\n    display: none !important;\n  } */\n  /* .customerContainer {\n    display: none !important;\n  } */\n\n  .fixedPosition {\n    display: none;\n  }\n}\n\n@media screen and (min-width: 900px) {\n  .fixedPosition1 {\n    display: none !important;\n  }\n}\n\n.fixedPosition1 {\n  margin-top: 5vh !important;\n}\n\n.systemHealthText1 {\n  font-size: 1rem;\n  margin-bottom: 0px;\n}\n\n.dark .systemHealthText1 {\n  color: white;\n}\n\n.light .systemHealthText1 {\n  color: black;\n}\n\n.systemHealthIcons1 {\n  color: green !important;\n  height: 5vh !important;\n  width: 8% !important;\n  margin-right: 10px;\n}\n\n.number {\n  color: #0562fb;\n  font-weight: 700 !important;\n  font-size: 15px;\n}\n\n.weight-wrapper-box {\n  display: flex;\n  margin-left: 6px;\n  font-size: 0.7em;\n  font-weight: 600;\n  color: #0562fb;\n  gap: 5px;\n}\n\n.no-data-wrapper-text {\n  font-size: 1.5rem;\n  letter-spacing: 0.25em;\n  font-weight: 600;\n  color: #353a50;\n}\n\n.dark .no-data-wrapper-text {\n  color: #fff !important;\n}\n\n.gtin-wrapper-box {\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  width: 100%;\n}\n\n.load-more-text-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.load-more-text-wrapper-btn {\n  padding: 5px;\n  background-color: transparent;\n  color: #0562fb !important;\n  border: none;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  border: 1px solid lightblue;\n  text-align: center;\n  border-radius: 3px;\n}\n\n.custom-error-modal-wrapper {\n  padding: 1rem !important;\n  max-width: 100vw;\n  max-height: 90%;\n  transform: translate(50%, -50%);\n  border-radius: 10px;\n  top: 50%;\n  left: 15%;\n  overflow-y: auto;\n  transition:\n    max-height 0.8s ease-in-out,\n    padding 0.8s ease-in-out;\n  outline: none !important;\n  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n  border: 1px solid lightblue;\n}\n\n.custom-error-modal-wrapper.show-solution {\n  max-height: 100%;\n}\n\n.error-custom-text {\n  font-size: 1.5rem;\n  margin-bottom: 0.5rem;\n  color: red;\n}\n\n.solution-error-custom-text {\n  font-size: 1rem;\n  margin-bottom: 1rem;\n  color: #0562fb;\n}\n\n.custom-error-ui {\n  list-style-type: none;\n  padding: 0;\n}\n\n.custom-error-ui li {\n  margin-bottom: 0.5rem;\n  font-size: 0.9rem;\n}\n\n.custom-error-btn {\n  background-color: #0562fb;\n  color: #fff;\n  padding: 0.5rem 1rem;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 1rem;\n  transition: background-color 0.3s;\n}\n\n@media only screen and (max-width: 720px) {\n  .forGridContainer {\n    display: grid;\n    grid-template-columns: 1fr;\n  }\n}\n\n/************ Redesigning Cart ***************/\n\n.particularCategoryContainerWrapper {\n  display: flex;\n  align-items: center;\n  gap: 18px;\n}\n\n.searchbarContainer {\n  padding: 0px 0px 10px 0px;\n  background: #f8fafc !important;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  width: 100%;\n  overflow-x: auto;\n  flex-wrap: nowrap;\n  scrollbar-width: none;\n}\n\n.searchbarContainer::-webkit-scrollbar {\n  display: none;\n}\n\n.searchbarContainer.dark {\n  background-color: var(--dark-blue) !important;\n}\n\n.centerItems {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n}\n\n.customHeaderContainer {\n  /* padding: 10px !important; */\n}\n\n.customHeaderContainer.dark {\n  background-color: var(--dark-blue);\n}\n\n.customSearchBar-div {\n  width: 100%;\n}\n\n.arrowPathRoundedSquareIcon {\n  display: flex;\n  padding: 2px 4px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  align-self: stretch;\n  border-radius: 4px;\n  background: #fff;\n}\n\n.newSearchContainer {\n  display: flex;\n  min-height: 40px;\n  justify-content: space-between;\n  align-items: center;\n  align-self: stretch;\n  width: 100%;\n  flex-wrap: wrap;\n  gap: 10px;\n  padding: 10px 5px;\n  border-top: 1.5px solid #e2e8f0;\n  border-bottom: 1.5px solid #e2e8f0;\n  background: #f8fafc;\n}\n\n.newSearchContainerLeftSection {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  align-self: stretch;\n  flex: 1;\n  min-width: 0;\n}\n\n.productLayoutTypes-rightSection {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.productLayoutTypes-row-view {\n  box-sizing: border-box;\n  display: flex;\n  width: 36px;\n  height: 36px;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n\n.productLayoutTypes-active-btn {\n  background: #0860e6;\n  color: #fff;\n}\n\n.productLayoutTypes-inactive-btn {\n  background: transparent;\n  color: #6b7280;\n}\n\n.add-product-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  height: 40px;\n  padding: 0 14px;\n  border: 1px solid #0860e6;\n  border-radius: 6px;\n  background: #fff;\n}\n\n.productLayoutTypes-active-border {\n  border: 1px solid #0860e6;\n}\n\n.productLayoutTypes-inactive-btn {\n  background: transparent;\n  color: #6b7280;\n}\n\n.add-product-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  height: 40px;\n  padding: 0 14px;\n  border: 1px solid #0860e6;\n  border-radius: 6px;\n  background: #0860e6;\n  color: #ffffff;\n  font-size: 0.8rem;\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n  transition:\n    background 0.15s,\n    border-color 0.15s;\n  font-family: inherit;\n}\n\n.add-product-btn:hover {\n  background: #0752c4;\n  border-color: #0752c4;\n}\n\n.productLayoutTypes-inactive-btn:hover {\n  background: #f3f4f6;\n  color: #374151;\n}\n/**********************************************/\n\n@media (min-width: 1020px) {\n  .customSearchBar-div {\n    width: 364px;\n  }\n}\n\n/* ═══════════════════════════════════════════\n   Static 3-Panel Layout\n   ═══════════════════════════════════════════ */\n\n.pcp-outer {\n  display: flex !important;\n  flex-direction: column !important;\n  height: calc(100vh - 56px) !important;\n  overflow: hidden;\n}\n\n.pcp-layout {\n  display: flex;\n  flex-direction: row;\n  flex: 1;\n  width: 100%;\n  overflow: hidden;\n  gap: 0;\n  /* padding-top: 6px;\n  margin-top: 10px; */\n  background-color: #fff;\n}\n\n/* ── Categories Panel ── */\n.pcp-category-panel {\n  background: #ffffff;\n  border-radius: 8px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n  min-width: 0;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);\n}\n\n/* Static panel layout */\n/* ── Products Panel ── */\n/* ── Cart Panel ── */\n/* Override rightContainer for non-Grid context */\n.pcp-cart-panel .rightContainer {\n  height: 100% !important;\n  display: flex !important;\n  flex-direction: column !important;\n}\n\n/* Ensure product grid fills remaining space in products panel */\n.pcp-products-panel .particularCategoryEachItemGridContainerCFSCartPage {\n  flex: 1;\n  height: 0; /* flex trick to fill remaining space */\n  min-height: 0;\n}\n\n/* Search bar stretches to fill available space in products panel */\n.pcp-products-panel .customSearchBar-div {\n  width: 100%;\n}\n\n/* ═══════════════════════════════════════════\n   Static 3-Panel Layout\n   ═══════════════════════════════════════════ */\n\n.pcp-outer {\n  display: flex !important;\n  flex-direction: column !important;\n  height: calc(100vh - 56px) !important;\n  overflow: hidden;\n}\n\n.pcp-layout {\n  display: flex;\n  flex-direction: row;\n  flex: 1;\n  width: 100%;\n  overflow: hidden;\n  gap: 0;\n  padding: 0;\n  background: #eef0f4;\n}\n\n/* ── Categories Panel ── */\n.pcp-category-panel {\n  background: #ffffff;\n  border-radius: 0;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n  min-width: 0;\n  box-shadow: none;\n  border-right: 1px solid #e2e8f0;\n}\n\n.pcp-resizer {\n  position: relative;\n  display: flex;\n  width: 1px;\n  align-items: center;\n  justify-content: center;\n  background-color: #e2e8f0;\n  cursor: col-resize;\n  flex-shrink: 0;\n  z-index: 10;\n  transition: background-color 0.15s ease;\n}\n\n.dark .pcp-resizer {\n  background-color: #334155;\n}\n\n/* Wider grab area overlay */\n.pcp-resizer::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 50%;\n  width: 8px;\n  transform: translateX(-50%);\n  cursor: col-resize;\n}\n\n\n.pcp-resizer-handle {\n  z-index: 10;\n  display: flex;\n  height: 16px;\n  width: 12px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 3px;\n  border: 1px solid #cbd5e1;\n  background-color: #f8fafc;\n  color: #64748b;\n  cursor: col-resize;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  transition: all 0.15s ease;\n}\n\n.dark .pcp-resizer-handle {\n  border-color: #475569;\n  background-color: #1e293b;\n  color: #94a3b8;\n}\n\n.pcp-resizer:hover .pcp-resizer-handle,\n.pcp-resizer:active .pcp-resizer-handle {\n  border-color: #0860e6;\n  background-color: #0860e6;\n  color: #ffffff;\n}\n\n.dark .pcp-resizer:hover .pcp-resizer-handle,\n.dark .pcp-resizer:active .pcp-resizer-handle {\n  border-color: #3b82f6;\n  background-color: #3b82f6;\n  color: #ffffff;\n}\n\n.pcp-resizer-handle svg {\n  width: 10px;\n  height: 10px;\n}\n\n.pcp-category-heading {\n  font-size: 0.7rem;\n  font-weight: 800;\n  color: #9ca3af;\n  padding: 12px 14px 10px;\n  border-bottom: 1px solid #f0f2f5;\n  flex-shrink: 0;\n  margin: 0;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  background: #fafbfc;\n}\n\n.pcp-category-body {\n  flex: 1;\n  scrollbar-width: thin;\n  scrollbar-color: #d1d5db transparent;\n}\n\n.pcp-category-body::-webkit-scrollbar {\n  width: 3px;\n}\n\n.pcp-category-body::-webkit-scrollbar-thumb {\n  background: #d1d5db;\n  border-radius: 4px;\n}\n\n/* Static panel layout */\n/* ── Products Panel ── */\n.pcp-products-panel {\n  flex: 1;\n  min-width: 200px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  background: #f8fafc;\n  border-radius: 0;\n  border: none;\n  border-right: 1px solid #e2e8f0;\n  box-shadow: none;\n  padding: 10px 10px 0;\n}\n\n/* ── Cart Panel ── */\n.pcp-cart-panel {\n  flex-shrink: 0;\n  height: 100%;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  border-radius: 0;\n  background: #f5f8ff;\n  border-left: 2px solid #c7d9f8;\n  box-shadow: -4px 0 16px rgba(8, 96, 230, 0.07);\n  position: relative;\n}\n\n/* Subtle top accent line on cart */\n.pcp-cart-panel::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: linear-gradient(90deg, #0860e6 0%, #4f9cf9 100%);\n  z-index: 1;\n}\n\n/* Override rightContainer for non-Grid context */\n.pcp-cart-panel .rightContainer {\n  height: 100% !important;\n  display: flex !important;\n  flex-direction: column !important;\n}\n\n/* Ensure product grid fills remaining space in products panel */\n.pcp-products-panel .particularCategoryEachItemGridContainerCFSCartPage {\n  flex: 1;\n  height: 0;\n  min-height: 0;\n}\n\n/* Search bar stretches to fill available space in products panel */\n.pcp-products-panel .customSearchBar-div {\n  width: 100%;\n}\n\n/* Filter chips row — enhanced */\n.searchbarContainer {\n  padding: 10px 2px !important;\n  background: #f8fafc !important;\n  border-bottom: 1px solid #f0f2f5;\n  margin-bottom: 2px;\n  gap: 6px !important;\n}\n\n/* ── Active filter chip override ── */\n.pcp-products-panel .searchbarContainer button {\n  box-shadow: none;\n  transition: all 0.15s ease !important;\n}\n\n.pcp-products-panel .searchbarContainer button:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12) !important;\n}\n\n/* ── Dark mode for 3-panel layout ── */\n.dark .pcp-layout {\n  background: #0f172a;\n}\n\n.dark .pcp-category-panel {\n  background: #1e293b;\n  border-right-color: #334155;\n}\n\n.dark .pcp-category-heading {\n  background: #162032;\n  color: #64748b;\n  border-bottom-color: #334155;\n}\n\n.dark .pcp-category-body {\n  scrollbar-color: #475569 transparent;\n}\n\n.dark .pcp-products-panel {\n  background: #0f172a;\n  border-right-color: #334155;\n}\n\n.dark .searchbarContainer {\n  background: #0f172a !important;\n  border-bottom-color: #334155;\n}\n\n.dark .pcp-cart-panel {\n  background: #111827;\n  border-left-color: #1d4ed8;\n}\n\n.dark .newSearchContainer {\n  background: #0f172a !important;\n  border-top-color: #334155;\n  border-bottom-color: #334155;\n}\n\n.dark .arrowPathRoundedSquareIcon {\n  background: #1e293b;\n}\n\n.dark .product-card-skeleton {\n  background: #1e293b;\n  border-color: #334155;\n}\n\n.dark .product-card-skeleton__image,\n.dark .product-card-skeleton__line,\n.dark .product-card-skeleton__dot,\n.dark .product-card-skeleton__price,\n.dark .product-card-skeleton__btn {\n  background: linear-gradient(90deg, #1e293b 25%, #334155 50%, #1e293b 75%);\n  background-size: 200% 100%;\n}\n\n.dark .particularCategoryEachItemGridContainerCFSCartPage {\n  scrollbar-color: #334155 transparent;\n}\n\n.dark .particularCategoryEachItemGridContainerCFSCartPage::-webkit-scrollbar-thumb {\n  background: #334155 !important;\n}\n\n/* Restaurant POS layout refinements */\n@media (min-width: 1024px) and (max-width: 1100px) {\n  .pcp-products-panel {\n    padding: 8px 8px 0;\n  }\n\n  .searchbarContainer {\n    gap: 5px !important;\n    padding: 8px 0 !important;\n  }\n\n  .pcp-products-panel .searchbarContainer button {\n    padding: 8px 12px !important;\n    font-size: 0.74rem !important;\n  }\n\n  .newSearchContainer {\n    gap: 8px;\n    padding: 8px 4px;\n  }\n\n  .productListInnerContainer-flex-row-wrap {\n    align-content: start;\n    gap: 10px;\n    overflow-x: hidden;\n    padding-bottom: 120px;\n  }\n\n  .particularCategoryEachItemCFS {\n    padding: 2px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
